import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Primeros Auxilios para Bebés',
    desc: 'Lo que necesitás saber para actuar rápido, sin miedo y con más seguridad en momentos importantes.',
    topics: ['fiebre', 'golpes y caídas', 'atragantamiento', 'RCP básico', 'cuándo ir a urgencias'],
    value: '$12.000',
    img: 'https://cdn.magicpatterns.com/uploads/gB8X6fSErs7rX3FEV7rvR2/BONUS_1.png'
  }, {
    num: '02',
    title: 'Carpeta Prenatal',
    desc: 'La carpeta organizadora para guardar estudios, ecografías y controles de tu embarazo.',
    topics: ['análisis', 'ecografías', 'controles', 'vacunas', 'documentos importantes'],
    value: '$8.500',
    img: 'https://cdn.magicpatterns.com/uploads/aDHpNoH34EWdq9chj5ns4S/BONUS_2.png'
  }, {
    num: '03',
    title: 'Primeras Comidas del Bebé',
    desc: 'Aprendé cómo empezar la alimentación complementaria sin estrés, sin miedo y paso a paso.',
    topics: ['primeros alimentos', 'cómo empezar', 'señales importantes', 'recetas simples', 'alimentación tranquila'],
    value: '$10.000',
    img: 'https://cdn.magicpatterns.com/uploads/xj3i1As8LYjGWHrGkdycYA/BONUS_3.png'
  }, {
    num: '04',
    title: 'Recuperar tu cuerpo después del embarazo',
    desc: 'Una guía realista y empática para acompañarte en el postparto sin presión ni culpa.',
    topics: ['autoestima postparto', 'diástasis abdominal', 'recuperación real', 'cuidados simples', 'maternidad sin exigencias'],
    value: '$12.000',
    img: 'https://cdn.magicpatterns.com/uploads/77Awq9gEqtw7TSkvwWLR4f/BONUS_4.png'
  }];
  return <section className="py-20 md:py-28 bg-peach-light/30 relative overflow-hidden" data-id="element-18">
      <div className="absolute top-20 left-10 grid grid-cols-4 gap-2 opacity-30" data-id="element-19">
        {[...Array(16)].map((_, i) => <div key={i} className="w-1.5 h-1.5 rounded-full bg-peach" data-id="element-20"></div>)}
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-21">
        <div className="text-center mb-16" data-id="element-22">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm font-bold tracking-[0.3em] text-peach-dark uppercase mb-4" data-id="element-23">
            <Gift className="w-4 h-4" data-id="element-24" /> 4 BONUS EXCLUSIVOS
          </span>
          <h2 className="font-serif text-text-dark leading-[1.05] tracking-tight mb-4" style={{
          fontSize: 'clamp(2rem, 5vw, 4rem)'
        }} data-id="element-25">
            Y además te llevás 4 regalos
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-26">
          {bonuses.map((bonus, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: idx * 0.1
        }} className="bg-white rounded-3xl overflow-hidden shadow-md border border-peach/20 flex flex-col sm:flex-row hover:shadow-xl transition-shadow" data-id="element-27">
              <div className="w-full sm:w-2/5 bg-gradient-to-br from-peach-light to-cream p-6 flex items-center justify-center" data-id="element-28">
                <img src={bonus.img} alt={bonus.title} className="w-full max-w-[180px] drop-shadow-xl" data-id="element-29" />
              </div>
              <div className="w-full sm:w-3/5 p-8 flex flex-col" data-id="element-30">
                <span className="inline-block self-start px-3 py-1 bg-peach text-white text-xs font-bold tracking-widest uppercase rounded-full mb-3" data-id="element-31">
                  BONUS {bonus.num}
                </span>
                <h3 className="text-xl font-serif font-bold text-text-dark leading-tight mb-2" data-id="element-32">
                  {bonus.title}
                </h3>
                <p className="text-text-muted text-sm leading-relaxed mb-4" data-id="element-33">
                  {bonus.desc}
                </p>
                <ul className="space-y-1 mb-6 flex-grow" data-id="element-34">
                  {bonus.topics.map((topic, tidx) => <li key={tidx} className="flex items-center gap-2 text-sm text-text-dark" data-id="element-35">
                      <span className="text-peach text-xs" data-id="element-36">🌸</span> {topic}
                    </li>)}
                </ul>
                <div className="flex items-center gap-3 pt-4 border-t border-peach-light" data-id="element-37">
                  <span className="text-text-muted line-through" data-id="element-38">
                    {bonus.value}
                  </span>
                  <span className="text-sage font-bold text-lg" data-id="element-39">GRATIS</span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mt-12 md:mt-16 bg-peach text-white rounded-[2.5rem] p-8 md:p-12 text-center shadow-xl shadow-peach/30 max-w-3xl mx-auto" data-id="element-40">
          <p className="text-sm font-bold tracking-[0.3em] uppercase opacity-80 mb-3" data-id="element-41">
            🎁 VALOR TOTAL DE LOS BONUS
          </p>
          <p className="font-serif italic leading-tight" style={{
          fontSize: 'clamp(2rem, 5vw, 3.5rem)'
        }} data-id="element-42">
            Más de <span className="line-through opacity-70" data-id="element-43">$42.500</span> en
            valor
          </p>
          <p className="font-serif font-bold mt-2" style={{
          fontSize: 'clamp(2rem, 5vw, 3.5rem)'
        }} data-id="element-44">
            totalmente GRATIS
          </p>
        </motion.div>
      </div>
    </section>;
}